import { useEffect } from 'react';
import { useTranslationsContext } from '../../../features/Translations/providers/TranslationsContextProvider';
import { AlertModal } from '../../components/AlertModal';
import { MeetDomainEvents } from '../../../features/Meet';
import { publish } from '../../../features/EventsBus';

export interface InvalidCodePageProps {
	message?: string;
	onRetry?: () => void;
}

export default function InvalidCodePage({ message, onRetry }: InvalidCodePageProps) {
	const { t } = useTranslationsContext();

	useEffect(() => {
		publish(MeetDomainEvents.invalidCode);
	}, []);

	return (
		<AlertModal
			type="error"
			title={t('errors.title')}
			message={message || t('errors.invalid_code')}
			onRetry={onRetry}
		/>
	);
}
